import React from 'react';

import styled from '@emotion/styled';

import { IconProps } from '../../IconsProps';

const StyledBackIcon = styled.svg<IconProps>`
  & .cls-1 {
    stroke: var(--du-color-grey, #969696);
    fill: var(--du-color-grey, #969696);
    stroke-width: 0.5;
  }

  &:hover,
  &.active {
    .cls-1 {
      stroke: var(--du-color-primary, #128370);
      fill: var(--du-color-primary, #128370);
      stroke-width: 1;
    }
  }
`;
const BackIcon = () => (
  <StyledBackIcon xmlns='http://www.w3.org/2000/svg' width='32' height='32' viewBox='0 0 32 32'>
    <rect id='Rectangle_4915' data-name='Rectangle 4915' width='32' height='32' fill='transparent' />
    <path
      id='Path_15861'
      data-name='Path 15861'
      d='M24.259,27.475,16.527,19.74,24.26,12,23,10.739l-9,9,9,9Z'
      transform='translate(-3 -4.239)'
      className='cls-1'
    />
  </StyledBackIcon>
);

export default BackIcon;
